import React from 'react'
import { MainBgImage } from '../../common'
import styled from 'styled-components'
import emotionStyled from '@emotion/styled-base'
import { ButtonLink, ScrollLink } from '../../common/Links'
import theme from '../../theme'
import { ContainerLg, H2 } from '../../GlobalStyles'

import Image from '../../../images/NextSteps/next-steps-hero.jpg'

export const CustomMainBgImage = emotionStyled(MainBgImage)`
  background-image: linear-gradient(rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.1)),
    url(${p => p.imageUrl}) !important;
  background-repeat: no-repeat;
  background-position: 50% 0% !important;
  background-size: 100%;
  background-size: cover;
  height: ${p => p.height || 400}px;
`

export const BackgroundImageWrapper = styled.div`
  text-align: center;
`

export const HeroButton = styled(ButtonLink)`
  margin-bottom: 50px;
  a {
    text-shadow: 0px 0px 0 rgba(0, 0, 0, 0.5);
    @media screen and (max-width: 350px) {
      padding: 11px 36px;
    }
  }
`

export const HomeMainImage = () => {
  return (
    <CustomMainBgImage height={840} position='flex-end' imageUrl={Image}>
      <BackgroundImageWrapper>
        <ContainerLg>
          <H2 marginBottom='52px'>It’s your introduction to millions.</H2>
          <HeroButton
            url='https://www.pga.com/account/coach-profile'
            bgColor={theme.colors.gold}
            borderColor={theme.colors.gold}
            color={theme.colors.white}
            bgHoverColor={theme.colors.darkGold}
            borderHoverColor={theme.colors.darkGold}
            btnStyle='secondary'
            padding='11px 64px'
            aria-label='Start Your Profile'
          >
            Start Your Profile
          </HeroButton>
        </ContainerLg>
      </BackgroundImageWrapper>
      <ScrollLink scrollTo='intro' />
    </CustomMainBgImage>
  )
}

export default HomeMainImage
